import {
  FETCH_INC_JIRA_LOADER,
  SET_JIRA_DATA,
  ADD_COMMENT_SUCCESS,
  ADD_COMMENT_FAILURE,
  UPLOAD_FILES_COMMENT_REQUEST,
  UPLOAD_FILES_PROGRESS,
  UPLOAD_FILES_SUCCESS,
  UPLOAD_FILES_FAILURE,
} from '../../redux/constants/constants';

const initialState = {
  incLoader: false,
  jiraData: null,
  isIncidentDrawerPopupOpen: null,
  actionSucess: null,
  uploading: false,
  progress: {},
  error: null,
};

export default function IncidentSidebarReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_INC_JIRA_LOADER:
      return {
        ...state,
        incLoader: action.payload.incLoader,
        actionSucess: null,
        isIncidentDrawerPopupOpen: null,
        progress: {},
      };
    case SET_JIRA_DATA:
      return {
        ...state,
        jiraData: action.payload.jiraData,
      };
    case ADD_COMMENT_SUCCESS:
      return {
        ...state,
        incLoader: false,
        actionSucess: true,
        isIncidentDrawerPopupOpen: false,
      };
    case ADD_COMMENT_FAILURE:
      return {
        ...state,
        incLoader: false,
        actionSucess: false,
        isIncidentDrawerPopupOpen: true
      };
    case UPLOAD_FILES_COMMENT_REQUEST:
      return { ...state, uploading: true, progress: {}, error: null };
    case UPLOAD_FILES_PROGRESS:
      return {
        ...state,
        progress: {
          ...state.progress,
          percent: action.payload.percent,
        },
      };
    case UPLOAD_FILES_SUCCESS:
      return { ...state, uploading: false, progress: {}, error: null };
    case UPLOAD_FILES_FAILURE:
      return { ...state, uploading: false, progress: {},error: action.error };
    default:
      return state;
  }
}